import { z } from 'zod';
import { stringToList } from '#screens/hosts/form/advanced/mappers/stringToList.ts';
import { validateDNSName } from './helpers/dns.ts';
import { reformatCommaList } from './helpers/list.ts';

export const DNS_DOMAINS_EMPTY_ERR = 'Enter a comma-separated list of domains';

const dnsDomainListSchema = z.string().superRefine((value, ctx) => {
  for (const domain of stringToList(value)) {
    const message = validateDNSName(domain);
    if (message) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message, fatal: true });
      return z.NEVER;
    }
  }
});

/**
 * Shared by `definednet.dns.match_domains` and `definednet.dns.search_domains`, which the api
 * validates identically.
 */
export const dnsDomainsSchema = z.string().transform(reformatCommaList).pipe(dnsDomainListSchema);

export const dnsDomainsRequiredSchema = dnsDomainsSchema.refine((value) => value.length !== 0, {
  message: DNS_DOMAINS_EMPTY_ERR,
});
